// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__51b71","tagButton":"styles_tagButton__JYt66","icon":"styles_icon__G_TS4","label":"styles_label__ix_wZ"};